import React, { forwardRef, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Button, Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import { useTranslation } from 'react-i18next';
import { EnterpriseMember } from 'models/Enterprises';
import { getUserFullName } from 'utils';

import './EditEntepriseValueModal.styles.scss';

type EditEntepriseValueModalProps = {
  className?: string;
  enterpriseMembersWithValue: EnterpriseMember[];
  dataType: string;
  oldValue: string;
  newValue: string;
  onConfirm: () => void;
} & ModalProps;

const EditEntepriseValueModal: React.ForwardRefRenderFunction<
  ModalRef,
  EditEntepriseValueModalProps
> = (props, ref) => {
  const {
    className,
    enterpriseMembersWithValue,
    dataType,
    oldValue,
    newValue,
    onConfirm,
    ...rest
  } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('edit-enteprise-value-modal', className);

  const { t } = useTranslation();

  return (
    <Modal
      ref={modalRef}
      className={classes}
      title={t('editEnterpriseValueModalTitle')}
      {...rest}
    >
      <p className="description">
        {t('editEnterpriseValueModalDescription', {
          dataType,
          newValue,
          oldValue,
        })}
      </p>

      <ol className="members-section">
        {enterpriseMembersWithValue.map(({ _id, firstName, lastName }) => (
          <li key={_id}>{getUserFullName(firstName, lastName)}</li>
        ))}
      </ol>

      <p>{t('areYouSureYouWantToContinue')}</p>

      <div className="actions">
        <Button variant="link" onClick={modal?.close}>
          {t('cancel')}
        </Button>

        <Button
          onClick={() => {
            onConfirm();
            modal?.close();
          }}
        >
          {t('confirm')}
        </Button>
      </div>
    </Modal>
  );
};

export default forwardRef(EditEntepriseValueModal);
